import { useRouter } from "next/router";
import { useEffect, useContext } from "react";
import Image from "next/image";

import { AuthContext } from "../../context/AuthContext";
import Layout from "../../components/layout";
import { createServerSupabaseClient } from "@supabase/auth-helpers-nextjs";
import { getUserOnboardingStatus } from "@/supabase";
import { BASE_IMAGE } from "../../utils/base64image";
import Link from "next/link";
import { GetServerSidePropsContext } from "next";
import { removeAllCookies } from "@/utils/remove";
import { useSupabaseClient } from "@supabase/auth-helpers-react";

export default function SignIn() {
  const supabaseClient = useSupabaseClient();

  const signInWithGoogle = async function () {
    await removeAllCookies();
    const { data, error } = await supabaseClient.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `https://instantapply.co/auth-callback?from=app&route=/sites`,
      },
    });
  };

  // const router = useRouter();
  // const user = useContext(AuthContext);

  async function handleAuth() {
    await signInWithGoogle();
  }

  // useEffect(() => {
  //   if (window.location.href.includes('signin#')) {
  //       window.location.href = '/dashboard';
  //   }
  //   console.log('user',user)
  //   //if it comes from the google sign up based on the supabase issue , we take it to dashboard
  //    if (user && window.location.href.includes('signin') && document.referrer.includes('accounts')) {
  //    window.location.href = '/dashboard';
  //   }
  //    if (user && document.referrer.includes('accounts')) {
  //   window.location.href = '/dashboard';
  //   }
  //    if(user && window.location.href.includes('signin')){
  //        window.location.href = '/dashboard';
  //   }
  // }, [user]);

  return (
    <div className="h-[85vh] md:h-[100vh] w-full flex relative">
      <Link
        href="/"
        className="inline-flex items-centerrelative z-50 absolute top-10 left-5 lg:top-3 lg:left-3"
      >
        <Image
          width={20}
          height={20}
          src="/assets/images/instantapply-logo.svg"
          className="mr-1 h-6 sm:h-9 "
          alt="InstantApply Logo"
        />
        <span className="self-center  font-silka text-lg font-medium whitespace-nowrap dark:text-white">
          InstantApply
        </span>
      </Link>
      <div className=" w-full md:w-1/2 h-full flex items-center justify-center flex-col">
        <div className="w-10/12 mx-auto flex items-center justify-center flex-col">
          <div className="relative hidden lg:block">
            <Link href="/" className="inline-flex items-centerrelative z-50">
              <Image
                width={24}
                height={24}
                src="/assets/images/instantapply-logo.svg"
                className="mr-1 h-6 sm:h-9 "
                alt="InstantApply Logo"
              />
              <span className="self-center font-silka text-xl font-medium whitespace-nowrap dark:text-white">
                InstantApply
              </span>
            </Link>
          </div>
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-2xl text-center lg:text-3xl mt-2 font-bold text-gray-600">
              Land Your Dream Job Using InstantApply
            </h1>
            <p className="text-md text-gray-500 text-center leading-6 mt-4">
              Join the ranks of successful job seekers who landed their dream
              role with our system for job applicants, including Resume
              analyzer, Job autofill , Job tracking and AI Coverletter
              generation{" "}
            </p>
            <button
              onClick={handleAuth}
              className="flex mt-8 w-[300px] h-[60px] border border-gray-600 bg-white hover:scale-105 transition-all  text-gray-600 items-center justify-center rounded-md "
            >
              <svg
                className="mr-2 h-6 w-6"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="github"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  fill="#4285F4"
                />
                <path
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  fill="#34A853"
                />
                <path
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  fill="#FBBC05"
                />
                <path
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  fill="#EA4335"
                />
                <path d="M1 1h22v22H1z" fill="none" />
              </svg>
              Sign In With Google
            </button>
          </div>
        </div>
      </div>
      <div className="relative hidden w-1/2 md:block h-full flex-2">
        <Image
          fill
          src="/assets/images/puzzle.jpg"
          alt="hero-img"
          style={{ objectFit: "cover" }}
          placeholder="blur"
          blurDataURL={BASE_IMAGE}
        />
      </div>
    </div>
  );
}
